module.exports = __webpack_public_path__ + "static/media/Rushfor.7e44db0b.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Rushfor.eot
// module id = 2982
// module chunks = 70